/**
 * The `type` values a WS message can carry — mirrors WsEventType.php on the
 * backend (Lib/Websocket/WsEventType.php). Kept in sync by hand; a value
 * added on one side without the other just means that event never routes.
 */
export const WsEventType = {
  NOTIFICATIONS_UPDATED: 'notifications-updated',
  CSR_PROMPT_ISSUED: 'csr-prompt-issued',
  CSR_PROMPT_RESOLVED: 'csr-prompt-resolved',
  CALL_QUEUE_UPDATED: 'call-queue-updated',
  RESCHEDULE_REQUEST_UPDATED: 'reschedule-request-updated',
  SCHEDULE_CONFLICTS_UPDATED: 'schedule-conflicts-updated',
  SMS_THREAD_UPDATED: 'sms-thread-updated',
  GMAIL_THREAD_UPDATED: 'gmail-thread-updated',
  AGENT_STATUS_UPDATED: 'agent-status-updated',
  /** Facebook lead created / thread changed — signal-only { lead_id } (SOCIAL_LEAD_UPDATED in PHP). */
  SOCIAL_LEAD_UPDATED: 'social-lead-updated',
  /** Unverified Addresses topbar badge's list may have changed — signal-only (TopbarBadgeService in PHP). */
  UNVERIFIED_ADDRESSES_UPDATED: 'unverified-addresses-updated',
  /** Auto-Schedule Failed topbar badge's list may have changed — signal-only (TopbarBadgeService in PHP). */
  AUTO_SCHEDULE_FAILURES_UPDATED: 'auto-schedule-failures-updated',
} as const;

export type WsEventType = (typeof WsEventType)[keyof typeof WsEventType];
